import { render, staticRenderFns } from "./USP.vue?vue&type=template&id=1447ec18&"
import script from "./USP.vue?vue&type=script&lang=ts&"
export * from "./USP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/app/components/base/Icon.vue').default})
